import { intl } from '../../../../../../i18n'
import { InlineTreeSelect } from '../components/InlineTreeSelect'
import { useTeamSelectOptions } from './hooks/useTeamSelectOptions'

type Props = {
  snapshotUuid: string
  value: string[]
  onChange: (value: string[]) => void
  multiSelect?: boolean
  height?: string
}

export const TeamTreeSelect = ({
  snapshotUuid,
  value,
  onChange,
  multiSelect = true,
  height = '300px',
}: Props) => {
  const { options, parentMap, isLoading } = useTeamSelectOptions({
    snapshotUuid,
  })

  return (
    <InlineTreeSelect
      options={options}
      parentMap={parentMap}
      value={value}
      onChange={onChange}
      multiSelect={multiSelect}
      height={height}
      loading={isLoading}
      placeholder={intl.formatMessage({
        id: 'versionReport.teamSelect.searchPlaceholder',
      })}
    />
  )
}
